
export default {
  "seabiscuit-na": {
    "id": "0oafydyk3lFfExEW61d7",
    "clientId": "f4e8a078-42f8-4ac7-bb51-12334403e33d"
  },
  "sfra-apac-kr": {
    "id": "0oag5ryn3g8FwMeuR1d7",
    "clientId": "059a5df6-3921-426c-b9e4-6ea5ce7e3706"
  },
  "sfra-apac-sea-th": {
    "id": "0oag5rvybsTibR2We1d7",
    "clientId": "f6a072c2-d1e6-4089-bc3c-5c4b8900fb58"
  },
  "sfra-eu": {
    "id": "0oag5rqv3v9fc5d6m1d7",
    "clientId": "d50ec3a9-aa7a-454b-8690-6c9233ed25f6"
  },
  "shop-app-android": {
    "id": "0oaeewkj1aWL8PzRd1d7",
    "clientId": "e98bad67-6bd9-4b5c-a8b9-a16513c1dddb",
    "hideContinueAsGuest": true,
    "translationOverrides": {
      "en-us": {
        "registration.signup.text": "Create Account",
        "registration.form.submit": "Create Account",
        "oie.registration.form.title": "Create Account",
        "oie.registration.form.submit": "Create Account",
        "oie.email.verify.alternate.instructions": "Enter the code in your email to continue.",
        "oie.email.verify.alternate.verificationCode.instructions": "Enter the code in your email to continue."
      }
    }
  },
  "shop-app-ios": {
    "id": "0oae5rdju6wv189Vd1d7",
    "clientId": "acf6ca6f-ada6-487c-96b2-581e366a1c11",
    "hideContinueAsGuest": true,
    "translationOverrides": {
      "en-us": {
        "registration.signup.text": "Create Account",
        "registration.form.submit": "Create Account",
        "oie.registration.form.title": "Create Account",
        "oie.registration.form.submit": "Create Account",
        "oie.email.verify.alternate.instructions": "Enter the code in your email to continue.",
        "oie.email.verify.alternate.verificationCode.instructions": "Enter the code in your email to continue."
      }
    }
  },
  "ua-next": {
    "id": "0oafyr49e6DR5YoJp1d7",
    "clientId": "7859cf22-c948-41f4-9815-bceeadac3a75",
    "hideContinueAsGuest": true
  }
}
	